import { render } from "./IconAnimalsHelped.vue?vue&type=template&id=3a96b8ee"
import script from "./IconAnimalsHelped.vue?vue&type=script&lang=js"
export * from "./IconAnimalsHelped.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__